/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { View, Image } from 'react-native';
import PropTypes from 'prop-types';
import { isWeb, isMobileWeb } from '@global/screens';
import { imageSource } from '@global/helpers';

// eslint-disable-next-line react/display-name
const ImageContainV2 = (props) => {
  const {
    source = '',
    compressWidth = isWeb ? 600 : 400,
    style = {},
    containerStyle = {},
    paddingHorizontal = 0,
    onChangeHeight = () => {},
  } = props;
  const url = source?.uri ? source.uri : source;
  const [imageHeight, setImageHeight] = useState(0);

  useEffect(() => {
    onHeight();
  }, [imageHeight]);

  const onHeight = () => {
    if (onChangeHeight) {
      onChangeHeight(imageHeight);
    }
  };

  const onLayout = async (e) => {
    try {
      const native = e.nativeEvent;
      await Image.getSize(
        url,
        (width, height) => {
          let realWidth = 0;
          if (native) {
            if (
              (isWeb || isMobileWeb) &&
              native.target &&
              native.target.clientWidth
            ) {
              realWidth = native.target.clientWidth;
            }
            if (
              !(isWeb || isMobileWeb) &&
              native.layout &&
              native.layout.width
            ) {
              realWidth = native.layout.width;
            }
          }
          if (paddingHorizontal) {
            realWidth -= paddingHorizontal * 2;
          }
          const getRatio = (a, b) => {
            for (let result = b; result > 1; result--) {
              if (a % result == 0 && b % result == 0) {
                a = a / result;
                b = b / result;
              }
            }
            return { width: a, height: b };
          };
          const ratio = getRatio(width, height);
          const finalWidthRatio = realWidth / ratio.width;
          const finalHeightRatio = finalWidthRatio * ratio.height;
          const finalHeight = finalHeightRatio ? finalHeightRatio : 250;
          setImageHeight(finalHeight);
        },
        (err) => console.log(err),
      );
    } catch (error) {}
  };

  return (
    <View {...props} style={containerStyle} onLayout={onLayout}>
      <Image
        source={{ uri: imageSource(source, compressWidth) }}
        style={[style, { height: imageHeight }]}
      />
    </View>
  );
};

ImageContainV2.propTypes = {
  source: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ImageContainV2;
